'use client';
import englishMessages from 'ra-language-english';
import { TranslationMessages } from 'ra-core';

const en: TranslationMessages = {
    ...englishMessages,
    resources: {
        drafts: {
            name: 'Draft |||| Drafts',
            actions: {
                create: "Save draft"
            },
            notifications: {
                created: "Draft saved"
            }
        },
        numberRanges: {
            name: 'Numberrange |||| Numberranges',
            title: 'Name',
            value: 'Value',
            firstNumber: 'First number',
            nextNumber: 'Next number',
            isUsed: 'Used',
            isDefault: 'Default',
            dialogs: {
                markAsDefault: 'Mark as default'
            },
            actions: {
                select: 'Select',
                add: "Please add a number range"
            },
            notifications: {
                markedAsDefault: '%{title} marked as default',
                add: "Add"
            }
        },
        uploadedInvoices: {
            name: 'Accounting record |||| Accounting records',
            incoming: 'Income',
            outgoing: 'Expenditure',
            accountId: 'Account number',
            reverseAccountId: 'Reverse account number',
            invoiceDate: 'Invoice date',
            bookingType: 'Bookingtype',
            amount: 'Amount',
            taxInPercent: 'Tax [%]',
            invoiceNumber: 'Invoicenumber',
            reverseInvoiceNumber: 'Reverse invoicenumber',
            ustId: 'UstId',
            carId: 'Car',
            businessPartnerId: 'Businesspartner',
            dialogs: {
                book: "Would you like to book in FreeFiBU?",
                create: "Create accounting record",
                upload: "Upload Invoices"
            },
            actions: {
                book: "Book invoice |||| Book %{smart_count} invoices",
                bookAndAdd: "Buchen und weiter",
                create: "Create accounting record",
                upload: "Upload invoices"
            },
            notifications: {
                book: "Invoice booked |||| Invoices booked",
                create: "Accounting record created",
                upload: "Invoices uploaded"
            }
        },
        reverseInvoices: {
            name: 'Reverse invoice |||| Reverse invoices',
            dialogs: {
                send: "Would you like to send this email?",
            },
            actions: {
                send: "Send",
            },
            notifications: {
                sent: "Revesre invoice sent",
            }

        },
        invoices: {
            name: 'Invoice |||| Invoices',
            grossAmount: 'Amount [gross]',
            netAmount: 'Amount [netto]',
            taxAmount: 'Tax',
            totalAmount: 'Amount',
            comment: "Comment",
            invoiceDate: 'Invoice date',
            invoiceState: 'State',
            invoiceType: 'Invoice type',
            pending: 'Pending',
            pastDue: 'Past due',
            paid: 'Paid',
            failed: 'Failed',
            canceled: 'Canceled',
            dueDate: 'Due date',
            invoiceNumber: 'Invoice number',
            createdAt: 'Created at',
            isSendByMail: 'Sent',
            isCanceled: 'Canceled',
            isBooked: 'Booked',
            numberRange: 'Numberrange',
            carId: 'Car',
            bookingPeriod: 'Booking period',
            bookingInfo: {
                bookingNumber: '#',
                bookingPeriodName: 'Period',
                amount: 'Amount',
                bookingText: 'Text',
                bookingDate: 'Date',
                taxInPercent: 'Tax'
            },
            form: {
                invoiceType: 'Invoice type',
                numberRange: 'Number range',
                invoiceAdress: 'Invoice adress',
                textTemplates: 'Text templates',
                items: 'Items'
            },
            dialogs: {
                create: "Would you like to create this %{invoiceType}?",
                cancel: "Would you like to create this reverse invoice?",
                send: "Would you like to send this email?",
                sendInvoiceReminder: "Would you like to send this invoice reminder?",
                book: "Would you like to book this invoice?",
                invalidPeriod: "Invoice date is not compatible to booking period",
                invalidItems: "Invoice items should be greater than 0",
                correlationInvoiceNotBooked: "You must first book the reverse invoice",
                car: "Please select a vehicle",
                noTaxWarning: "Warning: You missed to enter a taxnumber nor an ust id.",
                alreadyCanceled: "Invoice was already canceled.",
                addComment: "Add comment",
                removeComment: "Remove comment"
            },
            actions: {
                cancel: "Cancel",
                download: "Downlaod PDF",
                send: "Send",
                sendInvoiceReminder: "Send reminder",
                create: "Create invoice",
                book: "Book invoice",
                back: "Back to FreeFiBU",
                addComment: "Add comment",
                removeComment: "Remove comment"
            },
            notifications: {
                canceled: "Invoice canceled",
                downloaded: "Invoice downloaded",
                invoiceStateChanged: "Invoicestate changed",
                sent: "Invoice sent",
                invoiceReminderSent: "Invoice reminder sent",
                created: "Invoice created",
                booked: "Invoice booked",
                commentAdded: "Comment added.",
                commentRemoved: "Comment removed."
            },
            bulkActions: {
                book: {
                    label: "Book",
                    confirmTitle: "Book invoice |||| Book %{smart_count} invoices",
                    confirmBody: "%{smart_count} invoice selected. |||| %{smart_count} invoices selected.",
                    irreversibilityHint: "Bookings are hard to undo.",
                    breakdownTitle: "Selection overview",
                    breakdown: {
                        bookable: "Bookable"
                    },
                    reason: {
                        alreadyBooked: "Already booked",
                        saleCarInvoice: "Car sale invoice (manual vehicle selection required)",
                        invalidPeriod: "Outside booking period",
                        invalidItems: "Invalid invoice items",
                        backendError: "Booking error",
                        notLoaded: "Not loaded in current view"
                    },
                    summaryTitle: "Booking summary",
                    summaryBody: "%{success} of %{total} invoices booked successfully.",
                    errorsTitle: "Skipped / failed",
                    loadError: "Could not load invoices."
                }
            }
        },
        textTemplates: {
            name: 'Texttemplate |||| Texttemplates',
            textModelEmail: 'Emailtemplates',
            textMode: 'Invoicetemplates',
            title: 'Name',
            text: 'Text',
            textType: 'Texttype',
            isDefault: 'Default',
            setToDefault: 'Set to default',
            introduction: 'Introduction text',
            terms: 'Terms text',
            ending: 'Ending text',
            isSmallBusinessNotice: 'Notice small business',
            reverseChargeNotice: 'Notice reverse charge',
            deliveryDateNotice: 'Notice delivery date',
            sendInvoiceEmailText: 'Send Invoice',
            sendReverseInvoiceEmailText: 'Send reverse invoice',
            sendInvoiceReminderEmailTextStep1: 'Send first invoice reminder',
            sendInvoiceReminderEmailTextStep2: 'Send second invoice reminder',
            sendInvoiceReminderEmailTextStep3: 'Send third invoice reminder',
            action: {
                showTextModel: "Config invoice texts",
                hideTextModel: "Hide invoice texts"
            },
        },
        filter: {
            companyNameContains: 'Company',
            invoiceNumberContains: 'Invoice number',
            contactEmailContains: 'Email',
            productNameContains: 'Product name',
            fileNameContains: 'File name',
            nameContains: 'Name',
            grossAmountGt: 'Amount >=', 
            grossAmountLt: 'Amount <=', 
            invoiceDateGt: 'Invoice date >=',
            invoiceDateLt: 'Invoice date <=',
            dueDateGt: 'Due date >=',
            dueDateLt: 'Due date <=',
            isSendByMail: 'Sent',
            invoiceStateEq: 'State',
            numberRangeIdEq: 'Number range',
            bookingConfirmed: 'Booking confirmed',
            bookingInfosEqNull: 'Only unbooked'
        },
        contact: {
            name: 'Contact',
            gender: 'Gender',
            male: 'Mr.',
            female: 'Mrs.',
            lastName: 'Lastname',
            firstName: 'Firstname',
            fullName: 'Fullname',
            email: 'Email',
            phone: 'Phone'
        },
        company: {
            name: 'Company',
            userCompanyName: 'Company',
            companyName: 'Company',
            additionalAddress: 'Additional Address',
            street: 'Street',
            number: 'Number',
            postCode: 'Postcode',
            city: 'City',
            country: 'Country',
            email: 'Email',
            localCourt: 'Local court',
            hrbNumber: 'HRB number',
            managingDirector: 'Managing director',
            website: 'Website'
        },
        logo: {
            name: 'Logo',
            addLogo: 'Add logo',
            removeLogo: 'Remove logo'
        },
        bankAccount: {
            name: 'Bankaccount',
            bankName: 'Bankname',
            accountOwner: 'Account owner',
            iban: 'IBAN',
            bic: 'BIC'
        },
        customers: {
            name: 'Customer |||| Customers',
            invoices: 'Invoices',
            ustId: 'TaxId',
            statistic: {
                name: "Statistic",
                salesNet: "Sales [net]",
                salesGross: "Sales [brutto]",
                salesTax: "Sales tax"
            },
            message: {
                noEmail: "Customer has no email address"
            }
        },
        users: {
            name: 'User |||| Users',
            isSmallBusiness: 'Small business',
            defaultDuePeriod: 'Default due period',
            taxNumber: 'Taxnumber',
            federalState: 'Federal state',
            ustId: 'UstId',
            isUstIdHidden: 'Hide UstId on invoice',
            menu: {
                userData: 'User data',
                subscription: 'Subscription',
            },
            message: {
                notComplete: "Please complete your user data",
                noEmail: "User has no email address"
            },
            action: {
                complete: "Complete"
            }
        },
        mailServiceConfig: {
            name: 'Mailserver',
            email: 'Email',
            sender: 'Sendername',
            userName: 'User name',
            password: 'Password',
            host: 'Host',
            port: 'Port',
            useSsl: 'Ssl',
            message: {
                notConfigured: 'You have to configure your mail server first',
                success: 'Mail was sent',
                error: 'Mail was not sent'
            },
            action: {
                configure: 'Configure',
                testMail: 'Testmail',
                send: 'Send testmail'
            }
        },
        products: {
            name: 'Product |||| Products',
            productName: 'Productname',
            description: "Description",
            price: 'Price',
            tax_in_percent: 'Tax [%]'
        },
        uploadedFile: {
            fileName: 'Filename'
        },
        items: {
            name: 'Items',
            description: 'Description',
            quantity: 'Quantity',
        },
        invoiceTypes: {
            standardInvoice: 'Standard invoice',
            SmallBusinessInvoice: 'Smallbusiness invoice',
            euInvoiceService: 'EU invoice (service)',
            euInvoiceDelivery: 'EU invoice (delivery)',
            thirdCountryInvoiceService: 'Thirdcountry invoice (service)',
            thirdCountryInvoiceDelivery: 'Thirdcountry invoice (delivery)',
            Revenues13bInvoice: 'Revenues 13b invoice',
            SaleCarInvoice: 'Sale car invoice',
            SaleCapitalAssetsInvoice: 'Sale capital assets invoice'
        },
        common: {
            tax_in_percent: 'Tax [%]',
            price: 'Price',
            discount_in_percent: 'Discount [%]'
        },
        auditTrail: {
            name: "Audit trail",
            invoiceCreated: "Invoice created",
            invoiceSent: "Invoice sent",
            invoicePaid: "Invoice paid",
            invoiceMarkedAsPending: "Invoice marked as pending",
            invoiceMarkedAsPastDue: "Invoice markes as past due",
            invoiceCanceled: "Invoice canceled",
            commentForInvoiceAdded: "Comment added",
            commentForInvoiceRemoved: "Comment deleted",
            invoiceReminderCreated: "Invoice reminder created",
            invoiceReminderSent: "Invoice reminder sent"
        },
        dashboard: {
            invoices: {
                noContent: "Here you'll find on overview of your invoices.",
                title: "Invoices of the last %{smart_count} months",
                facts: {
                    count: "Invoices:",
                    netSum: "Total net:",
                    taxSum: "Total taxes:",
                    grossSum: "Total gross:"
                }
            },
            auditTrails: {
                noContent: "Here you'll find your last activities.",
                title: "Last %{smart_count} activities"
            },
            customers: {
                noContent: "Here you'll find your top customers.",
                title: "Top %{smart_count} customers"
            },
        },
        authentication: {
            login: {
                login: "Login",
                resetPassword: "Forgot your password?",
                register: "Register here.",
                notRegistered: "Not registered?",
            },
            sendResetPassword: {
                title: "Forgot your password?",
                description: "Wenn du deine Zugangsdaten vergessen haben, trage bitte nachfolgend deinen Benutzernamen oder die E-Mail-Adresse ein, mit der du dich registriert hast. Wir werden dir deine Zugangsdaten dann umgehend erneut an diese Adresse versenden.",
                action: "Passwort zurücksetzen",
                feedback: "In wenigen Minuten bekommst du eine Mail. Bitte klicke auf den Link, um das Passwort zurück zu setzen."
            },
            resetPassword: {
                title: "Neues Passwort",
                description: "Gib bitte ein neues Passwort ein. Das Passwort sollte mindestens 8 Zeichen lang sein.",
                action: "Passwort speichern",
                feedback: "Dein Passwort wurde geändert. Du kannst dich jetzt mit deinem neuen Passwort einloggen."
            },
            register: {
                title: "Registrierung",
                description: "",
                action: "Kostenlos registrieren",
                mailings: "(Optional) Ich bin damit einverstanden, dass die freeFiBU GmbH mich frühzeitig per E-Mail über kommende Änderungen an der Software oder den Paketen und Preisen informiert. Meine Einwilligung kann ich jederzeit widerrufen.",
                noTerms: "Du musst unsere AGB sowie die Datenschutzhinweise bestätigen.",
                feedback: "Vielen Dank, die Registrierung wurde versendet. In wenigen Minuten bekommst du eine Mail. Bitte klicke auf den Link, um die Registrierung abzuschließen."
            },
            setupUserLogin: {
                title: "Registrierung abschließen",
                description: "Gib bitte einen Username und ein Passwort ein. Das Passwort sollte mindestens 8 Zeichen lang sein.",
                action: "Passwort speichern"
            }      
        },
        authorization: {
            upgradeDialog: {
                title: "This feature is not included",
                description: "Please upgrade your subscription."
            }
        }      
    }
};

export default en;
